import React, { Component } from "react";
import ApiManager from "../../../managers/ApiManager";
import { showToast, TOAST_TYPE } from "deskera-ui-library";
import sanitizeSVG from '@mattkrick/sanitize-svg';

/*
PROPS
- data
- borderStyle
- showImagePopup
*/

class Image extends Component {
  inputOpenFileRef;
  imagePickerExists = false;

  constructor(props) {
    super(props);
    this.inputOpenFileRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showImagePopup && !this.imagePickerExists) {
      this.openImagePicker();
    }
  }

  render() {
    return (
      <>
        <img
          className="unselectable"
          src={this.props.data.value}
          alt=""
          style={{
            ...this.props.data.style,
            ...this.props.borderStyle,
          }}
          draggable={false}
          onDoubleClick={() => {
            if (!this.props.isEditing) { return }
            this.openImagePicker();
          }}
        />
        {this.getImagePicker()}
      </>
    );
  }

  openImagePicker = () => {
    this.imagePickerExists = true;
    this.inputOpenFileRef.current.click();
  };

  getImagePicker = () => {
    return (
      <input
        id="inputfile"
        type="file"
        accept="image/*"
        ref={this.inputOpenFileRef}
        style={{ display: "none" }}
        onClick={(e) => {
          this.initializeImageSelect();
          e.stopPropagation();
        }}
        onChange={(e) => {
          if (e.target.files.length > 0) {
            this.uploadImageToAWS(e.target.files[0]);
          }
        }}
      />
    );
  };

  async uploadImageToAWS(imageData) {
    const cleanImage = await sanitizeSVG(imageData)
    if (!cleanImage) {
        showToast("Image upload failed,seems like a malicious file. Please try uploading another image.", TOAST_TYPE.FAILURE);
        return;
    }
    ApiManager.getUploadFileURL(
      imageData,
      (url) => {
        this.props.onValueChange(url);
        this.imagePickerExists = false;
        this.props.onClosePopUp();
      },
      (err) => {
        showToast("Image upload failed", TOAST_TYPE.FAILURE);
        this.imagePickerExists = false;
      }
    );
  }
  initializeImageSelect = () => {
    document.body.onfocus = this.checkIt;
  };
  checkIt = () => {
    if (document.querySelector("#inputfile")) {
      let filesList = document.querySelector("#inputfile").files;
      if (filesList && filesList.length === 0) {
        this.imagePickerExists = false;
        this.props.onClosePopUp();
        return;
      }
    }
  };
}

export default Image;
